/**
 * Game Controller Class
 *
 * Handles the main game flow
 *
 * Also has some specific cascade reels functionality here
 */

/* module manages the main game this inherits from spinFunctions */

gameController = (function () {
  var _payWinsEvent = {};
  var _poppingSymbols = [];
  var _dropEvent = [];
  var _dropsRemaining = 0;
  var _reelToFrespinsBarFlying = 0;
  var _popAndDropCompleteEvent = 0;
  var _totalWinnings = 0;
  var _numberOfPops = 0;
  var _jackpotTask;
  var _currentTime;
  var _featureAwarded = false;
  var _animWinsFinished = false;
  var _singleAnimWinFinished = false;
  var _skipWin = false;
  var _bonusSymbolsLanded = 0;
  var _initialDropping = 0;
  var _bigWin = undefined;
  var _inBuyABonus = false;
  var inBuyABonusRecovery = false;
  var inRecovery = false;
  var _popData = [];
  var _allPopsComplete = false;
  const _symbolDisappearAnims = [];
  const _fairyBurstAnims = [];
  var _landedAnimsPlaying = [];
  var _symbolCallbackFired = [];
  let _fairyMultiplierView = undefined;
  let _frogView = undefined;
  var _freeSpinsMeter = undefined;
  var _modifierEventTriggered = false;
  let _eliminatedSymbols = [];
  var _spinBonusSounds = [
    "bonusLand1",
    "bonusLand2",
    "bonusLand3",
    "bonusLand2",
    "bonusLand3",
  ];
  var _isGameIdle = true;
  var _fullGameWinnings = 0;
  var _rng = new RNG();
  var _isPrePaid = false;
  let _anticipationView = undefined;
  let _numBonusSymbolsLanded = 0;
  let _reelNumToStartAnticipationDelay = -1;
  let _isSymbolNew = [];
  let _hasWildLandSoundPlayed = false;
  let _hasSymbolLandSoundPlayed = false;
  let _autoClickForReplayRewatchTimer = undefined;
  let _winningsMeterCapped = false;
  let _showingMaxWinPopup = false;
  let _maxWinShown = false;

  function autoClickForReplayRewatch(cb, time = 4000) {
    if (gdk.serverParser._inReplayMode || gdk.serverParser._inRewatchMode) {
      gameController.stopAutoClickForReplayRewatch(); // just in case
      _autoClickForReplayRewatchTimer = timerManager.addTimeout(time, cb);
    }
  }

  function stopAutoClickForReplayRewatch() {
    if (_autoClickForReplayRewatchTimer) {
      timerManager.stop(_autoClickForReplayRewatchTimer);
      _autoClickForReplayRewatchTimer = undefined;
    }
  }

  function resetWinnings() {
    _totalWinnings = 0;
    _numberOfPops = 0;
    _maxWinShown = false;
    _winningsMeterCapped = false;
  }

  function jackpotGame(task) {
    _jackpotTask.join();

    _bigWin.start(task.data.value, function () {
      _jackpotTask.leave();
    });
  }

  function recoverGame(task) {
    // Recovery game with encore
    if (
      task.data.metaData === "encore" &&
      gameData.encoreEnabled !== task.data.metaValue
    ) {
      // Clear any encore effects and stop them appearing again
      gameData.encoreEnabled = task.data.metaValue;

      // Put button in the right state if not already true
      var encoreButtonLB = resourceManager.get(
        "buttonContainer:buttonBar:luckyBetToggleButton"
      );

      if (encoreButtonLB._flags.showLuckyBetActive !== gameData.encoreEnabled) {
        encoreButtonLB.setRecovery();
      }
    }

    inRecovery = true;
    resourceManager.get("helpPageScrollContainer:helpPageScroll").close();

    if (task.data.metaData === "buyABonus" && task.data.metaValue) {
      gameController.inBuyABonus = true;
      inBuyABonusRecovery = true;

      let baseStake = gameData.recoveryStake;

      let stakeController = resourceManager.getController("stakeController");

      let stakes = stakeController.Stakes;
      let returnStake = stakes.find((stake) => stake === baseStake);

      if (!returnStake) {
        returnStake = stakes[0];
      }

      stakeController.requestChangeStake(returnStake);
      stakeController.requestChangeStake(baseStake, GLOBALS.BONUS_BUY);

      gameData.stakeMeter.set(baseStake);
    }
    if (!inBuyABonusRecovery) {
      initNewSpin();
    }
  }

  function updateStake(isEndGame = false) {
    const stakeController = resourceManager.getController("stakeController");
    const baseStake = stakeController.BaseStake;

    if (isEndGame && gameController.inBuyABonus) {
      const currentBuyBonusStake = stakeController.getCurrentStake(GLOBALS.BONUS_BUY);
      if (currentBuyBonusStake !== baseStake) {
        gameData.winningsMeter.set(0);
      }
    }

    const jackpotsContainer = resourceManager.get(
      "jackpotsView:JackpotsContainer"
    );
    const bpl = baseStake / 25;
    const luckyBetEnabled = gameData.encoreEnabled;

    stakeController.setStakeMultiplier(luckyBetEnabled ? 1.5 : 1);
    game.changeStake(baseStake * (luckyBetEnabled ? 1.5 : 1), bpl);
    stakeController.broadcastCurrentStake();
    jackpotsContainer.updatePots(baseStake);
  }

  function onPromotionStarted() {
    _isPromotion = true;
  }

  function onPromotionEnded() {
    _isPromotion = false;
  }

  function canEnableSkip() {
    return (
      gameController.stateMachine.ActiveStateName === "PAYWINS" && !_skipWin
    );
  }

  function initNewSpin() {
    // Start of new game
    gameController._receivedResponse = false;

    gameController._isGameIdle = false;

    gameController.resetWinnings();

    musicManager.onGameStart();

    gameController.reelsSpinning = [false, false, false, false, false]; //gameData.reels.length;
    gameData.winningsMeter.set(0);

    var config = resourceManager.get("slotContainer").Props.configValues;

    gameData.reels.forEach(function (value) {
      value.setSpinParameters({
        spinSpeed: config.spinSpeed,
        landOffset: config.landOffset,
        decelerationDistance: config.decelerationDistance,
      });
    });

    _payWinsEvent = undefined;
    gameController.spinTask = undefined;

    // clear reels here - then spin event will cause the new symbols to drop in
    slotMachine.clearReels();

    // this needs to go to an intermediate state until the drop is finished - then into reels_spinning
    gameController.stateMachine.switchState("CLEAR_REELS");

    // Update autoplay button text
    var spinsRemaining = autoplayManager.getRemainingRounds();
    var spinsRemainingStr =
      spinsRemaining > 0 ? String(spinsRemaining - 1) : "∞";

    resourceManager
      .getController("inputOverlord")
      .setText("autoplayCancelButton", spinsRemainingStr);
  }

  function startGame() {
    // Do not allow the user to spin if the buy bonus present is up
    let buyBonusPopUp = resourceManager.get("buyABonusContainer:buyBonusPopup");

    if (buyBonusPopUp.visible) return;

    _fairyMultiplierView.playFairyStartAnim();

    initNewSpin();

    var stakeController = resourceManager.getController("stakeController");
    let bpl = stakeController.BaseStake / stakeController.CurrentWinLineCount;

    gdk.startGame(
      {
        //numbers should came from the stake controller
        stake: stakeController.CurrentStake,
        numWinlines: stakeController.CurrentWinLineCount,
        bpl: bpl,
        metaData: {
          encore: gameData.encoreEnabled,
          buyABonus: false,
        },
      },
      function () {
        gdk.getNextGameOutcome(function () {});
      }
    );
  }

  function onAbortGame() {
    var slotMachine = GameSlotMachineFactory.getSlotMachine(0);

    // game aborted - reset reels to startup symbols
    for (var i = 0; i < slotMachine.reels.length; i++) {
      let reel = resourceManager.get("slotContainer:reelContainer:reel" + i);
      let startingSymbols = gameData.slotConfig.startingSymbols[i].symbols;
      let reelLength = gameData.slotConfig.startingSymbols[i].symbols.length;

      // Copy starting symbols from server
      for (var j = 0; j < reelLength; ++j) {
        reel.setReelSymbol(j, startingSymbols[j].value);

        // make sure the reel symbols are in the correct position
        reel.dropInitialSymbols(j, 1);
      }

      // just for completeness the off screen symbol
      reel.dropInitialSymbols(3, 1);
    }

    gameController.stateMachine.switchState("WAITING_FOR_SERVER");
  }

  function doPayWins(payWinsEvent) {
    _payWinsEvent = payWinsEvent;
    _payWinsEvent.join();
    _numberOfPops++;

    /// TODO SA Win levels may need tweaking
    if (!freespins.inFreespins /*!freespins.areFreeSpinsActive()*/) {
      if (_numberOfPops >= 3) {
        musicManager.fadeLevels(
          musicManager.REALLYBIGWINLEVEL,
          musicManager.fadeLevelTimeIn,
          musicManager.fadeLevelTimeOut,
          1,
          0
        );
      } else if (_numberOfPops === 2) {
        musicManager.fadeLevels(
          musicManager.MULTIWINLEVEL,
          musicManager.fadeLevelTimeIn,
          musicManager.fadeLevelTimeOut,
          1,
          0
        );
      } else if (_numberOfPops === 1) {
        musicManager.fadeLevels(
          musicManager.SINGLEWINLEVEL,
          musicManager.fadeLevelTimeIn,
          musicManager.fadeLevelTimeOut,
          1,
          0
        );
      }
    } else {
      // we do this once all cascades have finished on this spin
      //musicManager.freeSpinsNextLevel();
    }

    // Add to cumulative total winnings
    _skipWin = false;
    _totalWinnings += _payWinsEvent.data.totalLineWinnings;
    _fullGameWinnings += _payWinsEvent.data.totalLineWinnings;

    // if winnings <= stake then only highlight symbols (do NOT animate symbols) + display win amount
    // if winnings > stake then do all (highlight, animate + display win amount)
    gameController.canCelebrate = _totalWinnings > 0;
    gameController.showWinSymbolAnimationsAndCountUp =
      _totalWinnings >
      resourceManager.getController("stakeController").CurrentStake;

    _extraSpinsFlyingToTotem = 0;

    gameController.stateMachine.switchState("PAYWINS");
  }

  function preGameComplete(gameCompleteEvent) {
    doGameComplete(gameCompleteEvent);
  }

  async function doGameComplete(gameCompleteEvent) {
    // if (!_isPrePaid && !gameController.getIsRecovery()) {
    //   gameData.creditMeter.set(gameData.credit + _fullGameWinnings);
    // }

    _fairyMultiplierView.resetMultiplier();

    for (let i = 0; i < GLOBALS.NUMBER_OF_REELS; i++) {
      _anticipationView.stopAnticipation(i);
    }

    musicManager.onGameEnd();

    _fullGameWinnings = 0;
    gameController.stateMachine.switchState("END_GAME");
  }

  function autoplayStarted(autoplayData) {
    var spinsRemaining = autoplayManager.getRemainingRounds();
    var spinsRemainingStr = spinsRemaining >= 0 ? String(spinsRemaining) : "X";

    resourceManager
      .getController("inputOverlord")
      .setText("autoplayCancelButton", spinsRemainingStr);
  }

  function autoplayEnded(autoplayData) {
    resourceManager
      .getController("inputOverlord")
      .setText("autoplayCancelButton", "");
    if (!autoplayManager.dialog.container.visible) {
      resourceManager.get(
        "buttonContainer:buttonBar:autoplayButton:glow"
      ).visible = false;
    }
  }

  function onPopAndDropComplete(popAndDropCompleteEvent) {
    _popAndDropCompleteEvent = popAndDropCompleteEvent;

    if (popAndDropCompleteEvent.data.winnings > 0) {
      _popAndDropCompleteEvent.join();
      gameController.stateMachine.switchState("PAY_TO_WINNINGS");
    }

    // Hiding the bonus symbol if it appears below the reels
    if (reelManager.reels[0].symbolData[3].symbolId == 9) {
      reelManager.reels[0].children[0].children[3].visible = false;
    }
    if (reelManager.reels[1].symbolData[3].symbolId == 9) {
      reelManager.reels[1].children[0].children[3].visible = false;
    }
    if (reelManager.reels[2].symbolData[3].symbolId == 9) {
      reelManager.reels[2].children[0].children[3].visible = false;
    }
    if (reelManager.reels[3].symbolData[3].symbolId == 9) {
      reelManager.reels[3].children[0].children[3].visible = false;
    }
    if (reelManager.reels[4].symbolData[3].symbolId == 9) {
      reelManager.reels[4].children[0].children[3].visible = false;
    }
  }

  function onDropEvent(dropEvent) {
    _dropEvent = dropEvent;
    _dropEvent.join();

    _bonusSymsDropComplete = false;

    gameController.stateMachine.switchState("DROP_SYMBOLS");
  }

  function onModifierEvent(modifierEvent) {
    _eliminatedSymbols = modifierEvent.data.eliminatedSymbols;
    _modifierEventTriggered = true;
  }

  function onExtraSpinsRemaining(event) {}

  async function onDropComplete() {
    _dropsRemaining--;

    if (_dropsRemaining === 0) {
      if (_winningsMeterCapped === true && _maxWinShown === false) {
        await showMaxWinPopup();
      }

      gameController.stateMachine.switchState("WAITING_FOR_SERVER");

      _dropEvent.leave();
    }
  }

  async function showMaxWinPopup(extraDelay) {
    _maxWinShown = true;
    _showingMaxWinPopup = true;

    const maxWinPopup = resourceManager.get("maxWinPopup");
    const continueButton = resourceManager.get("maxWinPopup:continueButton");

    continueButton.interactive = false;

    if (extraDelay > 0) {
      await timerManager.delayAsync(extraDelay);
    }

    maxWinPopup.visible = true;
    gsap.fromTo(
      maxWinPopup,
      { alpha: 0 },
      {
        alpha: 1,
        duration: 0.5,
        onComplete: async () => {
          let resolver = null;
          const promise = new Promise((resolve) => {
            resolver = resolve;
          });

          continueButton.mousedown = continueButton.touchstart = () => {
            continueButton.interactive = false;
            resolver();
          };

          continueButton.interactive = true;

          await promise;

          continueButton.mousedown = continueButton.touchstart = undefined;

          gsap.fromTo(
            maxWinPopup,
            { alpha: 1 },
            {
              alpha: 0,
              duration: 0.25,
              onComplete: () => {
                maxWinPopup.visible = false;
                _showingMaxWinPopup = false;
              },
            }
          );
        },
      }
    );
  }

  function onFeatureAnnounced(task) {
    _numBonusSymbolsLanded = 0;
    _reelNumToStartAnticipationDelay = -1;
    _isSymbolNew = [];

    _featureAwarded = true;
  }

  function onFeatureEnded() {
    _featureAwarded = false;
  }

  function update(delta, time) {
    // Store time for wobble
    _currentTime = time;

    this.stateMachine.update();
  }

  function dimAllReels(dim) {
    for (var i = 0; i < reelManager.reels.length; i++) {
      reelManager.reels[i].dimAllSymbols(dim, 0x666666);
    }
  }

  function wobbleSymbol(symbol, amount, reel) {
    var prog = (_currentTime % 1000) / 1000 - reel * 0.1;
    var pos = Math.sin(Math.PI * 2 * prog) * amount;
    // TODO - decide if we still need to do this.
    //  symbol.position.set(0,pos);
  }

  //define gameController
  gameController = Object.create(spinFunctions);
  Object.defineProperties(gameController, {
    autoClickForReplayRewatch: { value: autoClickForReplayRewatch },
    stopAutoClickForReplayRewatch: { value: stopAutoClickForReplayRewatch },
    startGame: { value: startGame },
    resetWinnings: { value: resetWinnings },
    initNewSpin: { value: initNewSpin },
    totalWinnings: { value: _totalWinnings },
    doGameComplete: { value: doGameComplete },
    canEnableSkip: { value: canEnableSkip },
    numOfBonusSymbolsLanded: {
      get: function () {
        return _numBonusSymbolsLanded;
      },
    },
    isSymbolNew: {
      get: function () {
        return _isSymbolNew;
      },
    },
    isFeatureAwarded: {
      get: function () {
        return _featureAwarded;
      },
    },
    reelNumToStartAnticipationDelay: {
      get: function () {
        return _reelNumToStartAnticipationDelay;
      },
    },
    dimAllReels: { value: dimAllReels },
    rng: { value: _rng },
    inBuyABonus: {
      get: function () {
        return _inBuyABonus;
      },
      set: function (value) {
        _inBuyABonus = value;
      },
    },
    fairyBurstAnims: { value: _fairyBurstAnims },
  });

  gameController.resetSymbolCallbackFired = function () {
    _symbolCallbackFired = [];
  };

  gameController.cancelAutoplay = function () {
    resourceManager.getController("autoplayController").cancel();
  };

  /**
   * Set up the win flash animations
   *
   * To position this, use your symbol sizes and then move the slotContainer:particlesContainer in layout
   *
   */
  gameController.setupSymbolDisappearAnims = function () {
    for (let reel = 0; reel < 5; reel++) {
      const symbolDisappearAnims = [];
      const fairyBurstAnims = [];

      for (let row = 0; row < 3; row++) {
        const x = reel * 132;
        const y = row * 170;

        const symbolDisappear = resourceManager.createObject(
          "movie",
          "symbolDisappear_" + reel + "_" + row,
          "slotContainer:particlesContainer",
          {
            definition: "symbolFlash",
            x,
            y,
            anchor: 0.5,
            scale: 2,
            loop: false,
          }
        );
        symbolDisappear.gotoAndStop(0);
        symbolDisappearAnims.push(symbolDisappear);

        const fairyBurst = resourceManager.createObject(
          "movie",
          "fairyBurst" + reel + "_" + row,
          "slotContainer:particlesContainer",
          {
            definition: "fairyBurst",
            x: x - 5,
            y: y - 5,
            anchor: 0.5,
            scale: 2,
            loop: false,
          }
        );
        fairyBurst.gotoAndStop(0);
        fairyBurstAnims.push(fairyBurst);
      }

      _symbolDisappearAnims.push(symbolDisappearAnims);
      _fairyBurstAnims.push(fairyBurstAnims);
    }
  };

  gameController.getExplosionAnims = function () {
    return _symbolDisappearAnims;
  };

  gameController._receivedResponse = false;

  // State Machine //

  StateMachine.Create(gameController);

  gameController.stateMachine.addState("WAITING_FOR_SERVER", function () {});

  gameController.stateMachine.addState("WAIT_FOR_START", function () {
    gameController._isGameIdle = true;

    if (gameController.phase.once()) {
      resourceManager.getController("autoplayController").checkLimits();
    }
    if (gameController.phase.hold()) {
      if (!resourceManager.getController("autoplayController").LimitPopupOpen) {
        gameController.phase.step();
      }
    }
    if (gameController.phase.hold()) {
      // Waiting for player to do something
      if (autoplayManager.isAutoplayEnabled()) {
        if (
          autoplayManager.AP.getFields()["numberOfRounds"].currentValue !==
          autoplayManager.AP.roundsRemaining()
        ) {
          var timeToNext = 500;
          resourceManager.getController(
            "autoplayController"
          ).timeToNextAutoplay = timeToNext;
          gameController.phase.step();
        }
      }
    }
    if (
      gameController.phase.timed(
        resourceManager.getController("autoplayController").timeToNextAutoplay
      )
    ) {
      if (!autoplayManager.isAutoplayEnabled()) {
        gameController.phase.reset();
      }
    }
    if (gameController.phase.once()) {
      startGame();
    }
  });

  gameController.initialDropComplete = function (reelID) {
    --_initialDropping;
  };

  gameController.stateMachine.addState("CLEAR_REELS", function () {
    // when reels have cleared we can drop in new positions
    // clear reels has a callback to reduce reelsDropping count
    if (gameController.phase.enter()) {
      _initialDropping = gameData.reels.length;
      _numBonusSymbolsLanded = 0;
      _reelNumToStartAnticipationDelay = -1;
      _hasWildLandSoundPlayed = false;
      _hasSymbolLandSoundPlayed = false;
      gameController.resetSymbolCallbackFired();
      gameController.hideOverlay();
    }

    // TODO 23/05/22 this needs to hold until all initial reels are dropped AND the spin task has been received
    if (gameController.phase.hold()) {
      if (_initialDropping === 0) {
        gameController.phase.step();
      }
    }

    // drop intial symbols needs to have finished before we do spin task leave and the symbols should all have landed
    if (gameController.phase.once()) {
      //gameController.stateMachine.switchState("REELS_SPINNING");
      gameController.stateMachine.switchState("DROP_INITIAL_SYMBOLS");
    }
  });

  gameController.allLandAnimsFinished = function () {
    let finished = true;
    for (let i = 0; i < _landedAnimsPlaying.length && finished; i++) {
      for (let j = 0; j < _landedAnimsPlaying[i].length && finished; j++) {
        if ((_landedAnimsPlaying[i][j]?.landAnimFinished ?? true) != true) {
          finished = false;
        }
      }
    }
    return finished;
  };

  gameController.stateMachine.addState("DROP_INITIAL_SYMBOLS", function () {
    if (gameController.phase.hold()) {
      // don't proceed unless we receive the spin task
      if (gameController.spinTask !== undefined) {
        gameController.phase.step();
      }
    }

    _isPrePaid = gameController.spinTask?.data.isPrePaidGame;

    if (gameController.phase.once()) {
      if (gameController.spinTask.data.localRng != null) {
        gameController.rng.seed(gameController.spinTask.data.localRng);
      }

      _numBonusSymbolsLanded = 0;
      _reelNumToStartAnticipationDelay = -1;
      _isSymbolNew = [];
      _reelsSpinning = [true, true, true, true, true];
      _symbolCallbackFired = [];

      let _positions = gameController.spinTask.data.resultPanel.reelList.map(
        function (reel, index) {
          return reel.symbols.map(function (curr) {
            return curr.value;
          });
        }
      );

      // we need to have a random symbol as the first below which we can drop
      // off the symbol grid when new symbols all cascade in
      let randomBelow = [];
      let allowedSymbols = [0, 1, 2, 3, 4, 5, 6, 7]; // no 8 or 9 as we don't want wilds or a bonus to appear
      for (var i = 0; i < gameData.reels.length; i++) {
        randomBelow[i] = allowedSymbols[getRandom(allowedSymbols.length)];
      }

      let _symbolsAbove = [[0], [0], [0], [0], [0]];
      let _symbolsBelow = [
        [randomBelow[0]],
        [randomBelow[1]],
        [randomBelow[2]],
        [randomBelow[3]],
        [randomBelow[4]],
      ];

      // calculate whether we display landing symbols
      gameController.calcLandingAnims();

      // now drop the symbols in
      const cashPotData = gameController.spinTask.data.cashPotData;
      slotMachine.dropInitialSymbols(
        _symbolsAbove,
        _positions,
        _symbolsBelow,
        null,
        cashPotData
      );

      gameController.addOversizedSymbols();
    }

    if (gameController.phase.once()) {
      gameController._receivedResponse = true; // this allows slam stop
    }

    // don't proceed until all reels have finished spinning
    if (gameController.phase.hold()) {
      // check for any reels still spinning
      var spinComplete = true;
      for (
        var spinningIdx = 0;
        spinningIdx < _reelsSpinning.length;
        spinningIdx++
      ) {
        spinComplete = spinComplete && !_reelsSpinning[spinningIdx];
      }

      if (spinComplete) {
        gameController.phase.step();
        gameController._receivedResponse = false;
      }
    }

    // wait for all landing anims to finish playing
    if (gameController.phase.hold()) {
      // let anyPlaying = false;
      // for (var i = 0; i < _landedAnimsPlaying.length; i++) {
      //   let reelID = _landedAnimsPlaying[i][0];
      //   let row = _landedAnimsPlaying[i][1];

      //   let animStrip = resourceManager.get(
      //     reelManager.reels[reelID].linkedAnimations[0].name
      //   );
      //   if (animStrip.isAnimationPlaying(row)) {
      //     anyPlaying = true;
      //   }
      // }
      const anyPlaying = !gameController.allLandAnimsFinished();

      // all landing anims finished - hide them away
      if (!anyPlaying) {
        for (var i = 0; i < _landedAnimsPlaying.length; i++) {
          const reelID = _landedAnimsPlaying[i][0];
          const row = _landedAnimsPlaying[i][1];

          if (reelID != null && row != null) {
            const animStrip = resourceManager.get(
              reelManager.reels[reelID].linkedAnimations[0].name
            );
            animStrip.hideAnimation(row);
          }
        }

        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      gameController.stateMachine.switchState("WAITING_FOR_SERVER");

      if (gameController.spinTask) {
        gameController.spinTask.leave();
      }
    }
  });

  // handle the anims on landing - cascadeInfiniReels calls this callback
  // then we match up if it's a valid bonus symbol to play anim/sound
  gameController.onSymbolLandedCallback = function (
    landedReel,
    landedRow,
    isFromCascade = false
  ) {
    // var bonusLanded = false;
    let ignore = false;

    // check that we have't already fired this callback ( can be retriggered doing a slam stop )
    for (var i = 0; i < _symbolCallbackFired.length && !ignore; i++) {
      const firedReel = _symbolCallbackFired[i][0];
      const firedRow = _symbolCallbackFired[i][1];

      // if we've already fired this callback don't do it again
      if (
        landedRow === 3 ||
        (landedReel === firedReel &&
          landedRow === firedRow &&
          isFromCascade &&
          !_isSymbolNew[landedReel][landedRow])
      ) {
        ignore = true;
        // return;
      }
    }

    if (!ignore) {
      const BONUS_SYMBOL_ID =
        resourceManager.getConfiguration().symbols["Bonus"].ID;
      const landedSymbolID = reelManager.reels[landedReel].getSymbol(landedRow);

      const isBonusSymbol = landedSymbolID === BONUS_SYMBOL_ID;
      let isBonusFeaturePossible = false;

      if (isBonusSymbol) {
        // only play bonus anim and sound if it's possible to get bonus feature
        if (!isFromCascade) {
          if (
            landedReel <= 2 ||
            (landedReel === 3 && _numBonusSymbolsLanded >= 1) ||
            (landedReel === 4 && _numBonusSymbolsLanded >= 2)
          ) {
            isBonusFeaturePossible = true;
          }
        } else {
          let numOfReelsAfterLandedReelWithNewDrops = 0;
          for (let i = landedReel; i <= 4; i++) {
            if (_isSymbolNew[i].includes(true)) {
              numOfReelsAfterLandedReelWithNewDrops++;
            }
          }

          if (
            _numBonusSymbolsLanded >= 2 ||
            (_numBonusSymbolsLanded == 1 &&
              numOfReelsAfterLandedReelWithNewDrops >= 2) ||
            (_numBonusSymbolsLanded == 0 &&
              numOfReelsAfterLandedReelWithNewDrops >= 3)
          ) {
            isBonusFeaturePossible = true;
          }
        }

        if (isBonusFeaturePossible) {
          soundManager.play(_spinBonusSounds[landedReel]);
        }

        _numBonusSymbolsLanded++;
      } else if (
        landedSymbolID === resourceManager.getConfiguration().symbols["Wild"].ID
      ) {
        if (
          !slotMachine.slamStopRequested ||
          (slotMachine.slamStopRequested && !_hasWildLandSoundPlayed)
        ) {
          soundManager.play("wildLand");
          _hasWildLandSoundPlayed = true;
        }
      } else {
        if (
          !slotMachine.slamStopRequested ||
          (slotMachine.slamStopRequested && !_hasSymbolLandSoundPlayed)
        ) {
          soundManager.play("symbolLand");
          _hasSymbolLandSoundPlayed = true;
        }
      }

      if (_numBonusSymbolsLanded >= 2 && landedReel < 4) {
        _anticipationView.stopAnticipation(landedReel);
      } else if (landedReel === 4) {
        _anticipationView.stopAnticipation(4);
      }
      // we've got here so this must be the first time we've fired this callback - add to array
      _symbolCallbackFired.push([landedReel, landedRow]);

      // if we didn't play a sound on landing play it here - might need a different sound
      // don't play it on slam stop else the sounds all clash together
      // if (!bonusLanded) {
      //   let rand = Math.floor(Math.random() * 8) + 1;
      //   soundManager.play(`symbolLand_${rand}`);
      // }
      // look to see if we are to play a land anim here
      if (_landedAnimsPlaying[landedReel][landedRow] != null) {
        // land anim required
        // ask the reel to play the land anim for this symbol at position
        if (!isBonusSymbol || (isBonusSymbol && isBonusFeaturePossible)) {
          _landedAnimsPlaying[landedReel][landedRow].landAnimPromise =
            reelManager.reels[landedReel].playLandAnim(
              landedRow,
              _landedAnimsPlaying[landedReel][landedRow].symbolId,
              () => {
                _landedAnimsPlaying[landedReel][
                  landedRow
                ].landAnimFinished = true;
              }
            );
        } else {
          _landedAnimsPlaying[landedReel][landedRow].landAnimFinished = true;
        }
      }

      // // play landing anims as required
      // for (var i = 0; i < _landedAnimsPlaying.length; i++) {
      //   var reel = _landedAnimsPlaying[i][0];
      //   var row = _landedAnimsPlaying[i][1];

      //   if (landedReel === reel && landedRow === row) {
      //     soundManager.play(_spinBonusSounds[reel]);

      //     bonusLanded = true;
      //   }
      // }
    }
  };

  // Here we amend the layering for any oversized symbols so they're always on top
  gameController.addOversizedSymbols = function () {
    for (var l = 0; l < 3; l++) {
      for (let i = 0; i < 5; i++) {
        if (gameData.reels[i].symbolData[l].symbolId == 13) {
          // 13 = oversized bonus symbol
          gameData.reels[i].overlayOversizedSymbols(l);
        }
      }
    }
  };

  gameController.calcLandingAnims = function () {
    var bonusID = resourceManager.getConfiguration().symbols["Bonus"].ID;

    _landedAnimsPlaying = [];

    let bonusSymbolsLanded = 0;
    // this assumes we only get one bonus symbol visible per reel
    for (var reelID = 0; reelID < reelManager.reels.length; reelID++) {
      _landedAnimsPlaying[reelID] = [];

      for (var i = 0; i < 3; i++) {
        if (
          gameController.spinTask.data.resultPanel.reelList[reelID].symbols[i]
            .value === bonusID
        ) {
          const symbolId =
            gameController.spinTask.data.resultPanel.reelList[reelID].symbols[i]
              .value;
          _landedAnimsPlaying[reelID][i] = {
            reel: reelID,
            row: i,
            symbolId: symbolId,
            symbolId: bonusID,
            landAnimPromise: null,
            landAnimFinished: false,
          };

          bonusSymbolsLanded++;
          if (
            bonusSymbolsLanded >= 2 &&
            _reelNumToStartAnticipationDelay === -1
          ) {
            _reelNumToStartAnticipationDelay = reelID;
          }
        }
      }
    }
  };

  gameController.calcLandingAnimsForCascade = function (tempPopData) {
    const bonusID = resourceManager.getConfiguration().symbols["Bonus"].ID;

    _landedAnimsPlaying = [];

    // calcs which symbols are new drops
    const isSymbolNew = [];
    tempPopData.forEach((reel) => {
      // remove popped symbols from reel
      const isSymbolNewInReel = reel.filter((poppedSymbol) => !poppedSymbol);
      // then pad front of array until array length === 3
      for (let i = isSymbolNewInReel.length; i < 3; i++) {
        isSymbolNewInReel.unshift(true);
      }
      isSymbolNew.push(isSymbolNewInReel);
    });

    if (_numBonusSymbolsLanded >= 2) {
      _reelNumToStartAnticipationDelay = 0;
    }

    for (var reelID = 0; reelID < reelManager.reels.length; reelID++) {
      _landedAnimsPlaying[reelID] = [];

      for (var i = 0; i < 3; i++) {
        // if it's a new dropped bonus symbol, animate it
        if (isSymbolNew[reelID][i]) {
          if (gameData.reels[reelID].getSymbol(i) === bonusID) {
            const symbolId =
              gameController.spinTask.data.resultPanel.reelList[reelID].symbols[
                i
              ].value;
            _landedAnimsPlaying[reelID][i] = {
              reel: reelID,
              row: i,
              symbolId: symbolId,
              symbolId: bonusID,
              landAnimPromise: null,
              landAnimFinished: false,
            };
            if (
              _reelNumToStartAnticipationDelay === -1 &&
              _numBonusSymbolsLanded >= 2
            ) {
              _reelNumToStartAnticipationDelay = reelID;
            }
          }
        }
      }
    }

    _isSymbolNew = isSymbolNew;
    return isSymbolNew;
  };

  // when reel has landed all symbols - mark as no longer spinning
  gameController.onSpinCompleteBase = function (reelID) {
    _reelsSpinning[reelID] = false;
  };

  gameController.stateMachine.addState("REELS_SPINNING", function () {
    if (gameController.phase.enter()) {
      _reelsSpinning = [true, true, true, true, true];
    }

    if (gameController.phase.once()) {
    }

    if (gameController.phase.exit()) {
      // If the game has aborted the spin task will be undefined
      if (gameController.spinTask) {
        gameController.spinTask.leave();
      }
    }
  });

  gameController.stateMachine.addState("PAYWINS", function () {
    if (gameController.phase.once()) {
      gameController.showOverlay();

      _groupWinAmount = 0;
      _groupWinCount = 0;

      _animWinsFinished = false;
      _singleAnimWinFinished = false;
    }

    if (gameController.phase.once()) {
      _animWinsFinished = false;
      _singleAnimWinFinished = false;

      const { winningLines } = _payWinsEvent.data.winningLineEvent;
      const POT_SYMBOL_ID =
        resourceManager.getConfiguration().symbols["Pot"].ID;

      // if only win is pot win, we need to reset fairymultiplier before presenting pot wins
      if (
        winningLines.length === 1 &&
        winningLines[0].symbol.value === POT_SYMBOL_ID
      ) {
        if (!freespins.inFreespins) {
          _fairyMultiplierView.resetMultiplier();
        }

        const delay = _skipWin ? 0 : 1000;
        AllWaysPayWinAnimator.animatePotsOnly(
          _payWinsEvent.data,
          function () {
            _animWinsFinished = true;
          },
          function () {
            _singleAnimWinFinished = true;
          },
          delay,
          !gameController.showWinSymbolAnimationsAndCountUp
        );
      } else {
        // just regular wins
        AllWaysPayWinAnimator.animate(
          _payWinsEvent.data,
          function () {
            _animWinsFinished = true;
          },
          function () {
            _singleAnimWinFinished = true;
          },
          undefined,
          !gameController.showWinSymbolAnimationsAndCountUp
        );
      }
      // there isn't a case for regular wins AND pot wins
      // because pot wins are only paid on final cascade
      // and final cascades don't have regular wins otherwise they wouldn't be /final/ cascades
    }

    if (gameController.phase.hold()) {
      if (
        _singleAnimWinFinished ||
        (!gameController.canCelebrate && !freespins.inFreespins)
      ) {
        gameController.phase.step();
      }
    }

    if (gameController.canCelebrate || freespins.inFreespins) {
      if (!_payWinsEvent.data.isFinalCapped) {
        if (gameController.phase.once()) {
          soundManager.play("winCountUp");
          if (_frogView.isVisible()) _frogView.playFrogCascadeAnim();
        }

        if (_payWinsEvent.data.multiplier > 1) {
          if (gameController.phase.timed(2500)) {
            const appearProgress = Math.min(gameController.phase.Progress, 1);
            gameData.winningsText.setWinText(true);
            gameData.winningsText.show(true, 0);
            gameData.winningsText.setScale(
              appearProgress * 7 > 1 ? 1 : appearProgress * 7
            );
            gameData.winningsText.alpha =
              appearProgress * 7 > 1 ? 1 : appearProgress * 7;

            gameData.winningsText.animateMultiplyingWin(
              _payWinsEvent.data.preMultiplier,
              _payWinsEvent.data.multiplier,
              _payWinsEvent.data.totalLineWinnings,
              appearProgress
            );

            if (_skipWin) {
              soundManager.stop("winCountUp");
              gameData.winningsText.setScale(1);
              gameData.winningsText.alpha = 1;

              gameData.winningsText.animateMultiplyingWin(
                _payWinsEvent.data.preMultiplier,
                _payWinsEvent.data.multiplier,
                _payWinsEvent.data.totalLineWinnings,
                1
              );

              gameController.phase.step();
            }
          }
        } else {
          if (gameController.phase.timed(500)) {
            const appearProgress = Math.min(gameController.phase.Progress, 1);
            gameData.winningsText.setWinText(true);
            gameData.winningsText.show(true, 0);
            gameData.winningsText.setScale(appearProgress);
            gameData.winningsText.alpha = appearProgress;
            gameData.winningsText.setText(
              Math.floor(
                gameController.phase.Progress *
                  _payWinsEvent.data.totalLineWinnings
              )
            );

            if (_skipWin) {
              soundManager.stop("winCountUp");
              gameData.winningsText.setScale(1);
              gameData.winningsText.alpha = 1;

              gameController.phase.step();
            }
          }
        }

        if (gameController.phase.once()) {
          soundManager.stop("winCountUp");
          gameData.winningsText.playDiamondAnimation();
          gameData.winningsText.setScale(1);
          gameData.winningsText.alpha = 1;
          gameData.winningsText.setText(
            Math.floor(_payWinsEvent.data.totalLineWinnings)
          );
        }

        if (gameController.phase.timed(900)) {
        }
      }
    } else {
      if (gameController.phase.timed(400)) {
        _animWinsFinished = true;
      }
    }

    if (gameController.phase.hold()) {
      gameController.phase.step();
    }

    if (gameController.phase.once()) {
      if (_payWinsEvent.data.winningLineEvent.winningLines.length > 0) {
        gameController.stateMachine.switchState("AWARD_MULTIPLIER");
      } else {
        gameController.stateMachine.switchState("PRE_POP_SYMBOLS");
      }
    }

    if (gameController.phase.exit()) {
    }
  });

  gameController.skipWins = function () {
    _skipWin = true;
  };

  gameController.stateMachine.addState("AWARD_MULTIPLIER", function () {
    if (gameController.phase.once()) {
      gameController.stateMachine.switchState("PRE_POP_SYMBOLS");
    }
  });

  gameController.showOverlay = function () {
    if (darkOverlay === undefined) return;

    if (darkOverlayShowing) return;

    darkOverlayShowing = true;
    darkOverlay.visible = true;
    darkOverlay.alpha = 0;

    gsap.to(darkOverlay, {
      duration: 0.4,
      alpha: 0.3,
    });
  };

  gameController.hideOverlay = function () {
    if (darkOverlay === undefined) return;

    if (!darkOverlayShowing) return;

    darkOverlayShowing = false;

    gsap.to(darkOverlay, {
      duration: 0.4,
      alpha: 0,
      onComplete: () => {
        darkOverlay.visible = false;
      },
    });
  };

  gameController.stateMachine.addState("PRE_POP_SYMBOLS", function () {
    if (gameController.canCelebrate || freespins.inFreespins) {
      if (gameController.phase.timed(200)) {
        gameData.winningsText.setScale(
          1 + Math.sin(gameController.phase.Progress * Math.PI) * 0.2
        );
      }

      if (gameController.phase.timed(200)) {
        gameData.winningsText.setScale(1 - gameController.phase.Progress);
      }
    } else {
      if (gameController.phase.timed(100)) {
      }
    }

    if (gameController.phase.once()) {
      gameData.winningsText.setScale(1);
      gameData.winningsText.setText(
        Math.floor(
          gameController.phase.Progress * _payWinsEvent.data.totalLineWinnings
        )
      );

      if (!_payWinsEvent.data.isFinalCapped) {
        gameData.winningsMeter.countUp(
          _payWinsEvent.data.totalLineWinnings,
          200
        );
      }

      _poppingSymbols = [];

      _payWinsEvent.data.winningLineEvent.winningLines.forEach(
        (winningLine) => {
          winningLine.winSymPositions.forEach(({ reel, row }) => {
            _poppingSymbols.push({
              reel,
              row,
            });
          });
        }
      );

      gameData.winningsText.show(false);

      gameController.hideOverlay();

      gameController.stateMachine.switchState("WAITING_FOR_SERVER");

      _payWinsEvent.leave();
    }
  });

  gameController.stateMachine.addState("DROP_SYMBOLS", function () {
    if (gameController.phase.enter()) {
    }

    if (gameController.phase.timed(500)) {
      gameController.phase.step();
    }

    if (gameController.phase.once()) {
      _wildAppearSymbols = [];
      _wildsToShow = [];
      _wildTypeToShow = -1; //<--- NOTE -1 ARE THE SYMBOLS TO POP NOT THE WILDS
      _dropsRemaining = 5;
      _reelNumToStartAnticipationDelay = -1;
      _isSymbolNew = [];

      if (!_modifierEventTriggered) {
        _fairyMultiplierView.increaseMultiplier(
          _payWinsEvent.data.nextMultiplier
        );
      }
    }

    if (gameController.phase.timed(2500)) {
      gameController.phase.step();
    }

    if (gameController.phase.once()) {
      var slotMachine = GameSlotMachineFactory.getSlotMachine(0);
      _reelToFrespinsBarFlying = 0;
      _popData = [];
      _allPopsComplete = false;

      for (var reel = 0; reel < reelManager.reels.length; ++reel) {
        var popData = [];
        var totalDropping = 0;

        for (var row = 0; row < 3; ++row) {
          popData.push(_dropEvent.data.tumbleData[reel][row] !== 0);

          if (popData[row]) {
            totalDropping++;

            if (!_modifierEventTriggered) {
              _symbolDisappearAnims[reel][row].gotoAndPlay(0);
            }

            _allPopsComplete = true;
          }
        }

        if (_dropEvent.data.cells.length > 0) {
          _dropEvent.data.cells.forEach((cell) => {
            if (cell.reel === reel) {
              const reel = cell.reel;
              const row = cell.offset;

              const wildReel = reel;
              const wildRow = row;
              if (!_modifierEventTriggered) {
                soundManager.play("wildLand");

                gameData.reels[wildReel].showSymbol(wildRow, false);

                _symbolDisappearAnims[reel][row].gotoAndPlay(0);

                gameData.reels[reel].growSymbol(row);

                _symbolDisappearAnims[wildReel][wildRow].onComplete =
                  function () {
                    if (gameController.phase.timed(250)) {
                    }
                  };
              }
            }
          });
        }

        // Tell reels to pop (wait for drop)
        _popData.push(popData);

        if (_modifierEventTriggered) {
          // resetting alpha after modifier changes alpha in FairyMultiplierView.eliminateSymbol()
          _eliminatedSymbols.forEach((symbol) => {
            gameData.reels[reel].getReelSymbol(symbol.row).alpha = 1;
          });
        }

        // Use this to pop symbols off TODO SA 05/04 -1 means remove symbol array

        slotMachine.reels[reel].popSymbols(
          popData,
          _dropEvent.data.window[reel]
        );
      }
      if (!_modifierEventTriggered) {
        soundManager.play("symbolExplode");
      }
    }

    if (gameController.phase.hold()) {
      if (_allPopsComplete) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.timed(250)) {
      if (_modifierEventTriggered) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.timed(1500)) {
      gameController.phase.step();
    }

    if (gameController.phase.once()) {
      // Drop symbols
      const tempPopData = _popData;
      let delayTime = 250;
      let delayIndex = 0;

      _modifierEventTriggered = false;
      _popData = [];

      const isSymbolNew =
        gameController.calcLandingAnimsForCascade(tempPopData);
      const anticipationDelay =
        gameController.calculateDelaysForAnticipation(isSymbolNew, false);

      for (var i = 0; i < tempPopData.length; i++) {
        gameData.reels[i].dropSymbols(
          delayTime * delayIndex + anticipationDelay[i],
          tempPopData[i],
          onDropComplete,
          _dropEvent.data.cashPotData
        );

        // Only set a delay on the next reel if this one had a drop
        if (tempPopData[i][0] || tempPopData[i][1] || tempPopData[i][2]) {
          delayIndex++;
        }
      }

      for (let reel = 0; reel < reelManager.reels.length; ++reel) {
        if (tempPopData[reel] !== undefined) {
          for (let row = 0; row < 3; ++row) {
            if (tempPopData[reel][row]) {
              gameData.reels[reel].showSymbol(row, true);
            }
          }
        }
      }
    }

    if (gameController.phase.exit()) {
    }
  });

  gameController.stateMachine.addState("PAY_TO_WINNINGS", function () {
    if (gameController.phase.once()) {
      // Hide any bonus syms we've added, as they appear on top of the winnings view
      for (let i = 0; i < _landedAnimsPlaying.length; i++) {
        const reelID = _landedAnimsPlaying[i][0];
        const row = _landedAnimsPlaying[i][1];

        if (reelID != null && row != null) {
          const animStrip = resourceManager.get(
            reelManager.reels[reelID].linkedAnimations[0].name
          );
          animStrip.hideAnimation(row);
          animStrip.removeChildren();
        }
      }
    }

    if (gameController.phase.once()) {
      if (!freespins.inFreespins) {
        gameData.inputOverlord.setState("payToWinnings");
      }

      let amount =
        _popAndDropCompleteEvent.data.totalWinnings -
        gameData.winningsMeter.value;
      const isCapped = _payWinsEvent.data.isCapped;

      if (isCapped) {
        if (freespins.inFreespins) {
          amount = GLOBALS.getMaxWinValue() - gameData.winningsMeter.value;
        }
        gameData.winningsMeter.countUp(amount, 500);
        _winningsMeterCapped = true;
      }

      if (
        _popAndDropCompleteEvent.data.isCapped === true &&
        _winningsMeterCapped === true &&
        _maxWinShown === false
      ) {
        showMaxWinPopup();
      }
    }

    if (gameController.phase.hold()) {
      if (_showingMaxWinPopup !== true) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      const isBigWin = _bigWin.willTriggerBigWin(
        _popAndDropCompleteEvent.data.winnings
      );
      if (!freespins.inFreespins && isBigWin) {
        _bigWin.start(_popAndDropCompleteEvent.data.totalWinnings, undefined);
      }
    }

    if (gameController.phase.hold()) {
      if (!_bigWin.isBigWinActive()) {
        gameController.phase.step();
      }
    }

    if (
      (gameController.canCelebrate &&
        !_bigWin.willTriggerBigWin(_popAndDropCompleteEvent.data.winnings)) ||
      (freespins.inFreespins &&
        !_bigWin.willTriggerBigWin(_popAndDropCompleteEvent.data.winnings))
    ) {
      if (gameController.phase.timed(200)) {
      }

      if (gameController.phase.once()) {
        for (var i = 0; i < reelManager.reels.length; i++) {
          reelManager.reels[i].dimAllSymbols(true, 0x666666);
        }

        gameData.winningsText.setWinText(false); // uses 'total win' instead of 'win'
        gameData.winningsText.show(true, 0);
        if (gameController.showWinSymbolAnimationsAndCountUp) {
          soundManager.play("winCountUp");
        }
      }

      // grow to size and count up
      if (gameController.phase.timed(800)) {
        var appearProgress = Math.min(0.1 + gameController.phase.Progress, 1);
        gameData.winningsText.setScale(appearProgress);
        gameData.winningsText.alpha = appearProgress;
        const val = gameController.showWinSymbolAnimationsAndCountUp
          ? gameController.phase.Progress * (_totalWinnings / 2)
          : _totalWinnings;
        gameData.winningsText.setText(Math.floor(val));
      }

      if (gameController.phase.timed(800)) {
        const val = gameController.showWinSymbolAnimationsAndCountUp
          ? (gameController.phase.Progress * _totalWinnings) / 2 +
            _totalWinnings / 2
          : _totalWinnings;
        gameData.winningsText.setText(Math.floor(val));
      }

      if (gameController.phase.once()) {
        gameData.winningsText.playDiamondAnimation();
        soundManager.stop("winCountUp");

        gameData.winningsText.setScale(1);
        gameData.winningsText.alpha = 1;
        const val = gameController.showWinSymbolAnimationsAndCountUp
          ? gameController.phase.Progress * _totalWinnings
          : _totalWinnings;
        gameData.winningsText.setText(Math.floor(val));
      }

      if (gameController.phase.timed(1500)) {
      }

      if (gameController.phase.timed(500)) {
        gameData.winningsText.alpha = 1 - gameController.phase.Progress;
      }

      if (gameController.phase.once()) {
        gameData.winningsText.show(false);
        gameData.winningsText.alpha = 1;
        for (var i = 0; i < reelManager.reels.length; i++) {
          reelManager.reels[i].dimAllSymbols(false);
        }
      }
    }

    if (gameController.phase.once()) {
      if (freespins.inFreespins) {
        musicManager.freeSpinsNextLevel();
      }

      soundManager.stop("winCountUp");

      gameData.winningsMeterTitle.visible = true;
    }

    if (gameController.phase.timed(300)) {
    }

    if (gameController.phase.once()) {
      gameController.stateMachine.switchState("WAITING_FOR_SERVER");
    }

    if (gameController.phase.exit()) {
      if (!freespins.inFreespins) {
        gameData.inputOverlord.setState("enabled");
      }

      _popAndDropCompleteEvent.leave();
    }
  });

  gameController.stateMachine.addState("END_GAME", function () {
    if (gameController.phase.once()) {
      gameController.hideOverlay();

      updateStake(true);

      gameController.inBuyABonus = false;
      inRecovery = false;

      // End of game cycle

      gdk.endGame(function () {
        _dropEvent = [];
        _payWinsEvent = [];
        gameController.stateMachine.switchState("WAIT_FOR_START");
      });
    }
  });

  gameController.calculateDelaysForAnticipation = function (
    isSymbolNewInCascade = false, isInitialDrop = true
  ) {
    const delayInterval = isSymbolNewInCascade ? 100 : 500;
    let defaultDelay = 0;

    const license = gameData.license.toUpperCase();
    if (!isInitialDrop && license === 'DE') {
      const minGameTime = gdk.minGameTime;
      if (minGameTime > 2) {
        let multiplier = minGameTime * 0.5;
        // capped
        if (multiplier > 2.5) {
          multiplier = 2.5;
        }
        defaultDelay = 365 * multiplier;
      }
    }

    let currentDelay = 0;
    const reelDelays = [];
    for (let reelID = 0; reelID < 5; reelID++) {
      let delay = defaultDelay;
      if (
        _reelNumToStartAnticipationDelay !== -1 &&
        reelID > _reelNumToStartAnticipationDelay
      ) {
        currentDelay += delayInterval;
        delay = currentDelay;

        if (
          isSymbolNewInCascade !== false &&
          !(isSymbolNewInCascade?.[reelID] ?? []).includes(true)
        ) {
          delay = defaultDelay;
        }
      }
      if (
        _reelNumToStartAnticipationDelay !== -1 &&
        reelID > _reelNumToStartAnticipationDelay + 1
      ) {
        const extraDelay = 25 * 10 * 5; // 1 second
        currentDelay += extraDelay;
        delay = currentDelay;

        if (
          isSymbolNewInCascade !== false &&
          !(isSymbolNewInCascade?.[reelID] ?? []).includes(true)
        ) {
          delay = defaultDelay;
        }
      }

      reelDelays.push(delay);
    }

    return reelDelays;
  };

  gameController.initialise = function () {
    resourceManager.get("maxWinPopup").visible = false;
    resourceManager.get("maxWinPopup:continueButton").interactive = false;

    _anticipationView = resourceManager.get(
      "slotContainer:anticipationContainer:AnticipationView"
    );
    _bigWin = resourceManager.get("bigWin");
    _bigWin.init();
    freespins.initialise();
    _fairyMultiplierView = resourceManager.get(
      "fairyMultiplierContainer:FairyMultiplierView"
    );
    _frogView = resourceManager.get("frogContainer:FrogView");
    _freeSpinsMeter = resourceManager.get("freeSpinsMeter");
    _freeSpinsMeter.initialise();

    const slamStopButton = resourceManager.get(
      "buttonContainer:buttonBar:slamStopButton"
    );
    slamStopButton.canEnableBase = slamStopButton.canEnable;
    slamStopButton.canEnable = function () {
      return this.canEnableBase() && gameController._receivedResponse;
    };

    const volumeButton = resourceManager.get("buttonContainer:buttonBar:mute");
    volumeButton.canShowBase = volumeButton.canShow;
    volumeButton.canShow = function () {
      return this.canShowBase() && settingsMenu.buttons.btnSound.visible;
    };

    resourceManager.get(
      "buttonContainer:buttonBar:autoplayButton:glow"
    ).visible = false;

    darkOverlay = resourceManager.get("darkOverlay");
    darkOverlay.beginFill(0x000000);
    darkOverlay.lineStyle(0, 0x000000);
    darkOverlay.drawRect(0, 0, 1900, 1900);
    darkOverlay.visible = false;
    darkOverlayShowing = false;

    gameController.setupSymbolDisappearAnims();

    musicManager.onGameLoaded();
  };

  gameController.getIsRecovery = function () {
    return inRecovery;
  };

  gameController.getIsIdle = function () {
    return _isGameIdle;
  };

  gameController.globalHelperGetBaseStake = function () {
    return resourceManager.getController('stakeController').getBaseStake();
  };

  gameController.globalHelperGetStake = function (mode = undefined) {
    let stake = resourceManager.getController("stakeController").getBaseStake(mode);
    if (gameController.inBuyABonus) {
      stake *= 100;
    }

    return stake;
  };

  gameController.hasSkippedWin = function () {
    return _skipWin;
  };

  gameController.playWinningsSounds = function (winnings, stake) {
    if (winnings >= stake * 10) {
      soundManager.play(
        hiWinSounds[Math.floor(Math.random() * hiWinSounds.length)]
      );
    } else if (winnings >= stake * 5) {
      soundManager.play(
        medWinSounds[Math.floor(Math.random() * medWinSounds.length)]
      );
    } else if (winnings >= stake * 2) {
      soundManager.play(
        loWinSounds[Math.floor(Math.random() * loWinSounds.length)]
      );
    } else {
      soundManager.play("smallWin");
    }
  };

  ///////////////////
  // subscriptions //
  ///////////////////

  messageBus.subscribe("common:GameCompleteEvent", preGameComplete);
  messageBus.subscribe("autoplay:started", autoplayStarted);
  messageBus.subscribe("autoplay:ended", autoplayEnded);
  messageBus.subscribe("spinner:SpinEvent", gameController.onSpinEvent);
  messageBus.subscribe("spinner:WinningLinesEvent", doPayWins);
  messageBus.subscribe("game:DropEvent", onDropEvent);
  messageBus.subscribe("game:ModifierEvent", onModifierEvent);
  messageBus.subscribe("game:PopAndDropComplete", onPopAndDropComplete);
  //messageBus.subscribe("game:PopAndDropComplete", hideBonusSyms);
  // messageBus.subscribe("game:RespinEvent", onRespinIntro);
  // messageBus.subscribe("game:RespinEventDead", onRespinEvent);
  messageBus.subscribe("common:RecoverGame", recoverGame);
  messageBus.subscribe("common:JackpotGame", jackpotGame);
  messageBus.subscribe("platform:startNextGame", startGame);
  messageBus.subscribe("common:AbortGame", onAbortGame);
  messageBus.subscribe("game:ExtraSpinsRemaining", onExtraSpinsRemaining);
  messageBus.subscribe("game:FreeSpinsAwardEvent", onFeatureAnnounced);
  messageBus.subscribe("game:FreeSpinsEndEvent", onFeatureEnded);

  Reflex.addToUpdate(update.bind(gameController));

  messageBus.subscribe("common:PromotionStarted", onPromotionStarted);
  messageBus.subscribe("common:PromotionEnded", onPromotionEnded);

  gameController.canCelebrate = false;
  gameController.showWinSymbolAnimationsAndCountUp = false;
  gameController.multipliersComplete = false;

  gameController.stateMachine.switchState("WAIT_FOR_START");

  Object.seal(gameController);

  return gameController;
})();

function RNG() {
  const m = 0x80000000;
  const a = 1664525;
  const c = 1013904223;

  let state;

  this.seed = function (newSeed) {
    let seedToUse = newSeed;

    if (typeof newSeed === 'string') {
      let hash = 0;
      for (let i = 0; i < newSeed.length; i++) {
        hash = newSeed.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
      }
      seedToUse = Math.abs(hash);
    }
    state = seedToUse ? seedToUse : 0;
  };

  this.seed(0);

  this.nextInt = function () {
    state = (a * state + c) % m;
    return state;
  };

  this.nextFloat = function () {
    return this.nextInt() / (m - 1);
  };

  this.randomNumberFromTo = function (min, max) {
    min = Math.ceil(min);
    max = Math.floor(max + 1);
    return Math.floor(this.nextFloat() * (max - min)) + min;
  };

  this.passChance = function (perc = 100) {
    let pass = false;
    const random = this.randomNumberFromTo(1, 100);
    if (random <= perc) {
      pass = true;
    }
    return pass;
  };
}
